import { isBrowser } from '../utils';
import { TrackingMiddleware } from '../types';

const attachWindowParams: TrackingMiddleware = () => async event => {
  if (isBrowser()) {
    event.apply({
      absolute_uri: window.location.href,
      path: window.location.pathname,
      querystring: window.location.search,
      userAgent: window.navigator.userAgent,
    });

    event._deprecatedSetProprtiesInRoot(['path']);
  }
};

export default attachWindowParams;
